import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getPmsStoryCreateResult: host + 'reportResult/getPmsStoryCreateResult',//宣传部创建稿件
    getPmsStoryCheckResult: host + 'reportResult/getPmsStoryCheckResult',//宣传部审核稿件
};

export const getPmsStoryCreateResult = (body, callBack) => {  //单位线索统计
    request({url:Apis.getPmsStoryCreateResult, body, callBack});
};
export const getPmsStoryCheckResult = (body, callBack) => {  //宣传部审核稿件
    request({url:Apis.getPmsStoryCheckResult, body, callBack});
};